module.exports = __webpack_public_path__ + "img/fake-tag.6c349cfe.png";